import * as R from 'Router/routes';
import ValidationError, { FieldError } from 'utils/ValidationError';

export const routesWithAlreadyExistErrMsgManaged = [R.PERSONAL_DETAILS];

// Returns true when any field error signals a duplicate record (e.g. email already registered)
export const isAlreadyExistErrorMsg = (e: ValidationError) =>
  e.fieldErrors.some((error: FieldError) => {
    return error.messageTemplate === 'failed_to_complete_the_operation';
  });

export const ERRORS_TEMPLATES = {
  INCORRECT_CODE: 'incorrect_code',
};

export const isErrorTemplate = (e: unknown, errorTemplate: string) => {
  if (!(e instanceof ValidationError)) return false;
  return Boolean(
    e.fieldErrors.find(
      ({ messageTemplate }) => messageTemplate === errorTemplate,
    ),
  );
};
